import { BaseEntity } from '../../models';

export class ItemUnidade implements BaseEntity {
    id: number;
    idEmpresa: number;
    nome: string;
    fatorConversaoUnidade: number;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;
}
